import React from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { Button, Tag, TextField, TitleSubtitle } from "../..";
import { ButtonContainer, ButtonIcon, ButtonLabel, CTABackAndForthContainer } from "../../../pages/Register/Register.styles";
import { AccessibilityContainer, TagContainer } from "./Accessibility.styles";
import { useRegisterContext } from "../../../contexts/RegisterContext";
import { ButtonSwitch } from "../../ButtonSwitch/ButtonSwitch";
import { accessibilityOptionsMap } from "src/models/Accessibility";
import { FieldLengths, otherAccessibilityCounter } from "src/models/FieldLengths";

interface AccessibilityProps extends WithRouterProps {
    onNextButtonClick: Function;
    onPrevButtonClick: Function;
}

const Accessibility: React.FC<AccessibilityProps> = ({
    onNextButtonClick,
    onPrevButtonClick
}) => {

    const { registerInfo, setRegisterInfo, isAccessibilitySet, setIsAccessibilitySet } = useRegisterContext();
    const [isAccessibility, setIsAccessibility] = React.useState<boolean>(registerInfo.user.accessibility !== null ? true : false);
    const isNextButtonDisabled = () => {
        if (!isAccessibilitySet) {
            return true;
        }

        if (isAccessibility && !registerInfo.user.accessibility && !registerInfo.user.otherAccessibility) {
            return true;
        }

        return false;
    }

    const onOtherAccessibilityChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (event.target.value.trim().length > 0) {
            setRegisterInfo(prevRegisterInfo => ({
                ...prevRegisterInfo,
                user: {
                    ...prevRegisterInfo.user,
                    accessibility: "Other",
                    otherAccessibility: event.target.value
                }
            }));
        } else {
            setRegisterInfo(prevRegisterInfo => ({
                ...prevRegisterInfo,
                user: {
                    ...prevRegisterInfo.user,
                    accessibility: null,
                    otherAccessibility: null
                }
            }));
        }
    }

    return (
        <AccessibilityContainer>
            <TitleSubtitle
                size="sm"
                title="Any Accessibility Requirements?"
                subTitle="We need to ensure the venue has the appropriate set up for you." />
            <ButtonSwitch
                leftButtonChildren="Yes"
                rightButtonChildren="No"
                active={isAccessibilitySet ? (registerInfo.user.accessibility !== null ? "left" : "right") : undefined}
                onLeftButtonClick={() => { setIsAccessibilitySet(true); setIsAccessibility(true) }}
                onRightButtonClick={() => { setIsAccessibilitySet(true); setIsAccessibility(false) }}
            />
            {isAccessibilitySet && isAccessibility &&
                <>
                    <TagContainer>
                        {[...accessibilityOptionsMap].map(([key, value]) =>
                            <Tag
                                label={value}
                                isActive={registerInfo.user.accessibility === key}
                                isControlled
                                onClick={() => {
                                    setRegisterInfo(prevRegisterInfo => ({
                                        ...prevRegisterInfo,
                                        user: {
                                            ...prevRegisterInfo.user,
                                            accessibility: key
                                        }
                                    }))
                                }}
                                onDelete={() => {
                                    setRegisterInfo(prevRegisterInfo => ({
                                        ...prevRegisterInfo,
                                        user: {
                                            ...prevRegisterInfo.user,
                                            accessibility: null,
                                            otherAccessibility: null
                                        }
                                    }))
                                }} />
                        )}
                    </TagContainer>
                    <TextField
                        fullWidth
                        label="Other"
                        placeholder="Please Specify"
                        value={registerInfo.user.otherAccessibility}
                        onChange={onOtherAccessibilityChange}
                        inputProps={{ maxLength: FieldLengths.user.otherAccessibility }}
                        helperText={otherAccessibilityCounter(registerInfo.user.otherAccessibility)}
                    />
                </>
            }
            <CTABackAndForthContainer>
                <Button
                    size="md"
                    variant="tertiary"
                    onClick={() => onPrevButtonClick()}
                    data-cy="button-booking-next"
                    sx={{ padding: 0 }}
                >
                    <ButtonContainer>
                        <ButtonIcon icon="ArrowLeft" />
                        <ButtonLabel>Back</ButtonLabel>
                    </ButtonContainer>
                </Button>
                <Button
                    data-cy="register-accessibility-submit"
                    onClick={() => onNextButtonClick()}
                    disabled={isNextButtonDisabled()}
                > Continue </Button>
            </CTABackAndForthContainer>
        </AccessibilityContainer>
    );
};

Accessibility.displayName = "Accessibility";

const ComponentWithRouter = withRouter(Accessibility)

export { ComponentWithRouter as Accessibility };
